/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminGetAllJobs200Response,
  Job,
} from '../models/index';
import {
    AdminGetAllJobs200ResponseFromJSON,
    AdminGetAllJobs200ResponseToJSON,
    JobFromJSON,
    JobToJSON,
} from '../models/index';

export interface AdminAddJobRequest {
    job: Job;
}

export interface AdminDeleteJobRequest {
    id: number;
}

export interface AdminGetAllJobsRequest {
    page?: number;
    limit?: number;
    status?: AdminGetAllJobsStatusEnum;
    experienceLevel?: AdminGetAllJobsExperienceLevelEnum;
    jobType?: AdminGetAllJobsJobTypeEnum;
    title?: string;
    domainId?: number;
    categoryId?: number;
    subCategoryId?: number;
}

export interface AdminJobByIdRequest {
    id: number;
}

export interface AdminJobPublishRequest {
    id: number;
}

export interface AdminJobUpdateRequest {
    id: number;
    job: Job;
}

/**
 * 
 */
export class JobsApi extends runtime.BaseAPI {

    /**
     * Adds a new job listing
     * Create a new job
     */
    async adminAddJobRaw(requestParameters: AdminAddJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Job>> {
        if (requestParameters['job'] == null) {
            throw new runtime.RequiredError(
                'job',
                'Required parameter "job" was null or undefined when calling adminAddJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/job/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JobToJSON(requestParameters['job']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFromJSON(jsonValue));
    }

    /**
     * Adds a new job listing
     * Create a new job
     */
    async adminAddJob(requestParameters: AdminAddJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Job> {
        const response = await this.adminAddJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a job listing by ID
     * Delete a job
     */
    async adminDeleteJobRaw(requestParameters: AdminDeleteJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminDeleteJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/job/delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a job listing by ID
     * Delete a job
     */
    async adminDeleteJob(requestParameters: AdminDeleteJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminDeleteJobRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch paginated job listings with filters for status, experience level, job type, and title. Returns full associations (domain, category, subcategory, company).
     * Get all job listings
     */
    async adminGetAllJobsRaw(requestParameters: AdminGetAllJobsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGetAllJobs200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['experienceLevel'] != null) {
            queryParameters['experienceLevel'] = requestParameters['experienceLevel'];
        }

        if (requestParameters['jobType'] != null) {
            queryParameters['jobType'] = requestParameters['jobType'];
        }

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['domainId'] != null) {
            queryParameters['domainId'] = requestParameters['domainId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['subCategoryId'] != null) {
            queryParameters['subCategoryId'] = requestParameters['subCategoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/job/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGetAllJobs200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch paginated job listings with filters for status, experience level, job type, and title. Returns full associations (domain, category, subcategory, company).
     * Get all job listings
     */
    async adminGetAllJobs(requestParameters: AdminGetAllJobsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGetAllJobs200Response> {
        const response = await this.adminGetAllJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch a single job entry with associated entities
     * Get a job by ID
     */
    async adminJobByIdRaw(requestParameters: AdminJobByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Job>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminJobById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/job/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFromJSON(jsonValue));
    }

    /**
     * Fetch a single job entry with associated entities
     * Get a job by ID
     */
    async adminJobById(requestParameters: AdminJobByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Job> {
        const response = await this.adminJobByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish an existing job listing by ID
     * Update a Job
     */
    async adminJobPublishRaw(requestParameters: AdminJobPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Job>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminJobPublish().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/job/publish/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFromJSON(jsonValue));
    }

    /**
     * Publish an existing job listing by ID
     * Update a Job
     */
    async adminJobPublish(requestParameters: AdminJobPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Job> {
        const response = await this.adminJobPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing job listing by ID
     * Update a Job
     */
    async adminJobUpdateRaw(requestParameters: AdminJobUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Job>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminJobUpdate().'
            );
        }

        if (requestParameters['job'] == null) {
            throw new runtime.RequiredError(
                'job',
                'Required parameter "job" was null or undefined when calling adminJobUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/job/update/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JobToJSON(requestParameters['job']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFromJSON(jsonValue));
    }

    /**
     * Update an existing job listing by ID
     * Update a Job
     */
    async adminJobUpdate(requestParameters: AdminJobUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Job> {
        const response = await this.adminJobUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AdminGetAllJobsStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Closed: 'CLOSED'
} as const;
export type AdminGetAllJobsStatusEnum = typeof AdminGetAllJobsStatusEnum[keyof typeof AdminGetAllJobsStatusEnum];
/**
 * @export
 */
export const AdminGetAllJobsExperienceLevelEnum = {
    Entry: 'ENTRY',
    Mid: 'MID',
    Senior: 'SENIOR',
    Lead: 'LEAD',
    Executive: 'EXECUTIVE'
} as const;
export type AdminGetAllJobsExperienceLevelEnum = typeof AdminGetAllJobsExperienceLevelEnum[keyof typeof AdminGetAllJobsExperienceLevelEnum];
/**
 * @export
 */
export const AdminGetAllJobsJobTypeEnum = {
    Parttime: 'PARTTIME',
    Fulltime: 'FULLTIME',
    Freelance: 'FREELANCE',
    Contract: 'CONTRACT',
    Internship: 'INTERNSHIP'
} as const;
export type AdminGetAllJobsJobTypeEnum = typeof AdminGetAllJobsJobTypeEnum[keyof typeof AdminGetAllJobsJobTypeEnum];
